{
	"title": "Change password",
	"labels": {
		"company": "Company",
		"password": "Password",
		"confirmPassword": "Confirm password"
	},
	"fields": {
		"organization": {
			"placeholder": "Enter the company",
			"required": "The company is required"
		},
		"password": {
			"placeholder": "Enter your password",
			"required": "The password is required",
			"invalid": "Password is invalid"
		},
		"confirmPassword": {
			"placeholder": "Confirm your password",
			"required": "The confirmation of the password is required",
			"invalid": "The confirmation of the password is invalid"
		},
		"errors": {
			"required": "The field is required",
			"passwordMustBeSame": "The password and the confirmation of the password must be the same",
			"tokenRequired": "The token is required",
			"organizationRequired": "The organization is required"
		}
	},
	"submit": "Save new password",
	"successModal": {
		"title": "The new password has been saved successfully!",
		"subtitle": "Now you can access the Dashboard Zig with your new password.",
		"btnTitle": "Login"
	},
	"passwordRules": {
		"minLength": "Minimum 8 characters",
		"uppercase": "At least 1 uppercase letter",
		"lowercase": "At least 1 lowercase letter",
		"number": "At least 1 number",
		"special": "At least 1 special character (!@#$...)"
	},
	"passwordRuleState": {
		"passed": "met",
		"failed": "not met"
	},
	"passwordStrength": {
		"weak": "Weak",
		"fair": "Fair",
		"strong": "Strong",
		"veryStrong": "Very strong",
		"ariaLabel": "Password strength: {{level}}"
	},
	"passwordMatch": {
		"mismatch": "Passwords do not match"
	}
}
